import {isFeatureEnabled} from '@github-ui/feature-flags'
import {TerminalIcon, TriangleDownIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, Button} from '@primer/react'
import {useCallback, useMemo} from 'react'

import styles from './OpenInLocalAgentButton.module.css'

type OpenInLocalAgentButtonProps = {
  title: string
  url: string
}

function buildVSCodeAgentUrl(title: string, issueUrl: string): string {
  const prompt = `Work on the following GitHub issue: ${issueUrl}\n\nTitle: ${title}`
  const doubleEncoded = encodeURIComponent(encodeURIComponent(prompt))
  return `vscode://github.copilot-chat?mode=agent&prompt=${doubleEncoded}`
}

export function OpenInLocalAgentButton({title, url}: OpenInLocalAgentButtonProps) {
  const enabled = isFeatureEnabled('issues_open_in_tool_links')
  if (!enabled) return null

  return (
    <div className={styles.container}>
      <OpenInLocalAgentButtonInner title={title} url={url} />
    </div>
  )
}

function OpenInLocalAgentButtonInner({title, url}: OpenInLocalAgentButtonProps) {
  const vsCodeUrl = useMemo(() => buildVSCodeAgentUrl(title, url), [title, url])

  const handleOpenInVSCode = useCallback(() => {
    window.open(vsCodeUrl, '_self')
  }, [vsCodeUrl])

  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <Button size="medium" leadingVisual={TerminalIcon} trailingVisual={TriangleDownIcon}>
          Open in VS Code
        </Button>
      </ActionMenu.Anchor>
      <ActionMenu.Overlay>
        <ActionList>
          <ActionList.Item onSelect={handleOpenInVSCode}>Open in VS Code</ActionList.Item>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
